import { render } from "./ImageLoadingBox.vue?vue&type=template&id=4bb55609&scoped=true"
import script from "./ImageLoadingBox.vue?vue&type=script&lang=js"
export * from "./ImageLoadingBox.vue?vue&type=script&lang=js"

import "./ImageLoadingBox.vue?vue&type=style&index=0&id=4bb55609&scoped=true&lang=css"

import exportComponent from "H:\\Productions\\CS\\inc\\helpers\\cs-restaurants\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb55609"]])

export default __exports__